import React from 'react';
import { styled } from '@linaria/react';

interface Props {
  size?: number;
  label: string;
  color: string;
  isActive: boolean;
}

const CuteFile = ({ size = 48, label, color, isActive }: Props) => {
  const clipPath = `polygon(0% ${isActive ? 6 : 12}px, ${
    isActive ? 6 : 12
  }px 0%, 100% 0%, 100% 100%, 0% 100%)`;
  const translateBy = isActive ? -6 : 0;

  return (
    <Wrapper
      style={{
        width: size,
        height: size * ASPECT_RATIO,
      }}
    >
      <File
        style={{ clipPath, '--translate-by': translateBy + 'px' }}
      />
      <FileShadow>
        <File style={{ background: 'black', clipPath }} />
      </FileShadow>
      <Label style={{ background: color }}>{label}</Label>
    </Wrapper>
  );
};

const ASPECT_RATIO = 11 / 8.5;
const BORDER_RADIUS = 4;

const Wrapper = styled.div`
  position: relative;
`;

const File = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: ${BORDER_RADIUS}px;
  transition: clip-path 400ms;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 12px;
    height: 12px;
    border-radius: 0 0 ${BORDER_RADIUS}px 0;
    box-shadow: 1px 2px ${BORDER_RADIUS / 2}px rgba(0, 0, 0, 0.2);
    transition: transform 400ms;
    transform: translate(var(--translate-by), var(--translate-by));
  }
`;
const FileShadow = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  filter: blur(8px);
  transform: translate(1%, 3%);
  opacity: 0.2;
`;

const Label = styled.span`
  display: block;
  font-size: 11px;
  font-weight: 900;
  color: white;
  position: absolute;
  z-index: 3;
  padding: 0 5px;
  bottom: 20%;
  left: 0;
  transform: translateX(-3px);
  text-transform: uppercase;
`;

export default CuteFile;
